import * as types from './actionsTypes';

export type SaveEsrogActionType = {
  type: string;
  kind: string;
  pitum: boolean;
  headers: any;
  onSuccess?: () => void;
};

export const saveEsrogAction = (
  kind: string,
  pitum: boolean,
  headers: any,
  onSuccess?: () => void
): SaveEsrogActionType => ({
  type: types.SAVE_NEW_ESROG,
  kind,
  pitum,
  headers,
  onSuccess,
});
